import React from 'react';

import clsx from 'clsx';

interface InputProps extends React.ComponentProps<'input'> {
  className?: string;
  type?: string;
}

function Input({
  className,
  type = 'text',
  ...props
}: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={clsx(
        'form-control rounded-2',
        className
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}

export { Input };
